<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-1">Datos Venta</h5>
                                    </v-col>
                                    <v-col cols="6" md="6" class="text-end">
                                        <v-btn @click="open_venta()" color="warning" x-small rounded dark>&nbsp;&nbsp;&nbsp;Modificar Venta&nbsp;&nbsp;&nbsp;</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date1" label="Fecha" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" md="11" class="mt-n7">
                                        <v-select class='text-body-2' v-model="profesional" :items="myProfesional" label="Profesional" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>

                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex">
                                        <h5 class="mt-1">Selecciona Cliente</h5>
                                        <v-btn @click="d_cliente=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">
                                    <v-col cols="12" md="6" class="mt-n7">
                                        <v-text-field label="Rut" maxlength="10" class='text-body-2' v-model="rut" dense outlined rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="12" class="mt-n7">
                                        <v-text-field label="Nombre" class='text-body-2' v-model="cliente" dense outlined rounded></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" class="d-flex">
                                        <h5 class="mt-1">Selecciona Producto</h5>
                                        <v-btn @click="d_producto=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-10">
                                    <!-- <v-col cols="12" md="4" class="mt-n7">
                                        <v-text-field label="Sku" maxlength="10" class='text-body-2' v-model="sku" dense outlined rounded disabled></v-text-field>
                                    </v-col> -->
                                    <v-col cols="12" md="12" class="mt-n7">
                                        <v-text-field label="Producto" class='text-body-2' v-model="producto" dense outlined rounded disabled></v-text-field>
                                        <h6 class="mt-n7 ml-5">Sku: {{ sku }}</h6>
                                    </v-col>
                                    <v-col cols="5" md="5" class="mt-n5">
                                        <v-text-field type="number" label="Precio" maxlength="10" class='text-body-2' v-model="precio" dense outlined rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="5" md="5" class="mt-n5">
                                        <v-text-field type="number" label="Cantidad" class='text-body-2' v-model="cantidad" dense outlined rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="2" md="2" class="mt-n5">
                                        <v-btn @click="add_item()" class="mt-1" x-small color="indigo" dark rounded fab><v-icon small>add</v-icon></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>                    
                    </v-col>
                </v-row>
                <h5 class="mt-5">DETALLE DE LA VENTA</h5>
                <v-row>
                    <v-col cols="12" md="8">
                        <v-simple-table fixed-header dense height="250" style="border:1px solid lightgray" class="text-size">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;width: 15%;">Sku</th>
                                    <th style="background-color: lightgrey;width: 50%;">Producto</th>
                                    <th style="background-color: lightgrey;width: 10%;">Precio</th>
                                    <th style="background-color: lightgrey;width: 10%;">Cantidad</th>
                                    <th style="background-color: lightgrey;width: 10%;">Total</th>
                                    <th style="background-color: lightgrey;width: 5%;">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in myDetalle" :key="item.ID">
                                    <td><span>{{ item.sku }}</span></td>
                                    <td><span>{{ item.producto }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.precio)) }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.cantidad)) }}</span></td>
                                    <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.total)) }}</span></td>
                                    <td><v-icon @click="delete_line(item)" small color="red">delete</v-icon></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-sheet style="border:1px solid lightgray" height="250" width="100%" rounded="xl">
                            <v-container>
                                <v-row>
                                    <v-col cols="6" md="6">
                                        <h5 class="mt-1">Datos del Pago</h5>
                                    </v-col>
                                    <v-col cols="6" md="6" class="text-end">
                                        <h2>${{ new Intl.NumberFormat("de-DE").format(parseFloat(total_venta)) }}</h2>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-7">
                                    <!-- <v-col cols="12" md="6" class="mt-n7">
                                        <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date1" label="Fecha" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined rounded></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                        </v-menu>
                                    </v-col> -->
                                    <v-col cols="12" md="10">
                                        <v-select class='text-caption' v-model="forma" :items="myFormaPago" label="Forma de Pago" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-5">
                                    <v-col cols="6" md="6">
                                        <v-btn @click="clsInput()" color="teal" small rounded block dark>Limpiar</v-btn>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <div v-if="btn_modifica!=false">
                                            <v-btn v-if="btn_venta!=true" @click="modifica_venta()" color="teal" small rounded block dark>modificar venta</v-btn>
                                            <v-btn v-else color="grey" small rounded block dark>modificar venta</v-btn>
                                        </div>
                                        <div v-else>
                                            <v-btn v-if="btn_venta!=true" @click="save_venta()" color="teal" small rounded block dark>generar venta</v-btn>
                                            <v-btn v-else color="grey" small rounded block dark>generar venta</v-btn>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_cliente" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Clientes
                    <v-spacer></v-spacer>
                    <v-icon @click="d_cliente=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <div class="hidden-sm-and-down"> <!-- Full Screen -->
                        <v-text-field v-model="search" label="Buscar" style="width: 250px;"></v-text-field>
                        <v-data-table height="300px" fixed-header @click:row="handClients" dense 
                            :search="search" :headers="titulo" :items="myClientes" 
                            :page.sync="page" :items-per-page="itemsPerPage" @page-count="pageCount = $event" 
                            hide-default-footer class="elevation-1 text-size">
                        </v-data-table>
                    </div>
                    <div class="hidden-sm-and-up"> <!-- Mobile Screen -->
                        <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Rut</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handClients(item)" v-for="item in myClientes" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Rut }}</span></td>
                                    <td><span class="text-body-2">{{ item.Cliente }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_producto" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Productos
                    <v-spacer></v-spacer>
                    <v-icon @click="d_producto=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Rut</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handProducts(item)" v-for="item in myProducts" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Sku }}</span></td>
                                    <td><span class="text-body-2">{{ item.Producto }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="d_venta" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-title>
                    Modificar Venta
                    <v-spacer></v-spacer>
                    <v-icon @click="close_venta()">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <v-text-field label="N° Venta" type="number" class='text-body-2' v-model="numero" dense outlined rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-n7 text-center">
                            <v-btn @click="search_number()" color="teal" small rounded block dark>buscar número</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <img id="logo_solarium" src="@/assets/logo_solarium.jpg" height="0" width="0">        
        
        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 11pt !important;
    height: 30px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
import { jsPDF } from "jspdf";
export default {
    name: 'Ventas',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        menu1:false,
        date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        rut:'',
        cliente:'',
        sku:'',
        producto:'',
        precio:'',
        cantidad:'',
        forma:'',
        total_venta:0,
        d_cliente:false,
        myClientes:[],
        d_producto:false,
        myProducts:[],
        myFormaPago:[],
        myVenta:[],
        id_detalle:0,
        myDetalle:[],
        btn_venta:false,
        numero_folio:0,

        profesional:'',
        myProfesional:[],

        //modificar
        d_venta:false,
        numero:0,
        btn_modifica:false,

        search:'',
        titulo:[
          {text: 'Rut',align: 'start',sortable: true, value: 'Rut', width:'30%', class:['backgroud-color: grey ']},
          {text: 'Cliente',align: 'start',sortable: true, value: 'Cliente', width:'70%', class:['backgroud-color: grey ']},
        ],
        page: 1,
        itemsPerPage: 1000000,
        pageCount: 0,

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(2);
            if(parseInt(this.bloqueo)!=0){
                await this.search_users();
                await this.search_clientes();
                await this.search_productos();
                await this.search_formas();
            }
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        open_venta(){
            this.clsInput();
            this.btn_modifica=true;
            this.d_venta=true;
        },
        close_venta(){
            this.clsInput();
            this.btn_modifica=false;
            this.d_venta=false;
        },
        clsInput(){
            this.date1=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
            this.rut='';
            this.cliente='';
            this.sku='';
            this.producto='';
            this.precio='';
            this.cantidad='';
            this.forma='';
            this.total_venta=0;
            this.id_detalle=0;
            this.myDetalle=[];
            this.btn_venta=false;
            this.numero_folio=0;
            this.numero=0;
            this.btn_modifica=false;
            this.profesional = '';
        },
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async search_users(){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' :  this.user,
                    'usuario' :  'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.tipo=='Profesional'){
                            this.myProfesional.push(element.usuario)
                        }
                    })
                }
            } catch (error) {
                console.log(error);
            }
        },
        async search_clientes(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'clients' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/clients/',params,{headers});
                const datos = res.data;
                console.log('clientes',datos);
                if(datos[0].existe=='si'){
                    this.myClientes = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_productos(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'products' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/products/',params,{headers});
                const datos = res.data;
                console.log('productos',datos);
                if(datos[0].existe=='si'){
                    this.myProducts = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_formas(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'forma' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/type/payments/',params,{headers});
                const datos = res.data;
                console.log('forma de pago',datos);
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myFormaPago.push(element.Forma)
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        handClients(line){
            this.rut = line.Rut;
            this.cliente = line.Cliente;
            this.d_cliente = false;
        },
        handProducts(line){
            this.sku = line.Sku;
            this.producto = line.Producto;
            this.d_producto = false;
        },
        add_item(){            
            if(this.precio!=null && this.precio!='' 
                && this.cantidad!=null && this.cantidad!=''
                && this.sku!=null && this.sku!=''
                && this.producto!=null && this.producto!=''){
                    //calculamos el total
                    const total_line = parseFloat(this.precio) * parseFloat(this.cantidad);
                    this.id_detalle = parseInt(this.id_detalle) + 1;
                    this.myDetalle.push({
                        'id': this.id_detalle,
                        'sku': this.sku,
                        'producto': this.producto,
                        'precio': this.precio,
                        'cantidad': this.cantidad,
                        'total': total_line
                    });
                    this.total_venta = parseFloat(this.total_venta) + parseFloat(total_line);
                    this.sku='';
                    this.producto='';
                    this.precio='';
                    this.cantidad='';
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos del producto';
                this.snack=true
            }
        },
        delete_line(fila){
            this.myDetalle = this.myDetalle.filter(function(dat) {
                 return dat.id !== fila.id; 
            });
            this.total_venta = parseFloat(this.total_venta) - parseFloat(fila.total);
        },
        async folio_venta(){
            let result = 0;
            const now = new Date();
            const data_now = now.getFullYear()+''+now.getMonth()+''+now.getDate()+''+now.getHours()+''+now.getMinutes()+''+now.getSeconds();
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'referencia' : data_now,
                };
                //grabar nuevo folio
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/folio/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    //obtener el folio grabado
                    const res1 = await axios.post(process.env.VUE_APP_URL + '/api/v1/get/folio/',params,{headers});
                    const datos1 = res1.data;
                    if(datos1[0].existe=='si'){
                        this.numero_folio=datos1[0].ID;
                        result = datos1[0].ID;
                    }
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async liquida_date(){
            let result = false;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'fecha': this.date1,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/liquida/date/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = true
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        async save_venta(){
            this.loading=true;
            if(parseFloat(this.total_venta)!=0){
                 if(this.rut!=null && this.rut!='' && this.cliente!=null && this.cliente!=''){
                    if(this.forma!=null && this.forma!=''){
                        //verificar si la fecha ya esta liquidada
                        const verify_date = await this.liquida_date();
                        if(verify_date){
                            this.btn_venta=true;
                            this.color_snack='error';
                            this.mensaje='La fecha ya esta liquidada';
                            this.snack=true
                        } else {
                            try {
                                const headers = {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Token ' + this.apikey
                                };
                                //obtener el id_venta
                                const folio = await this.folio_venta();
                                if(parseInt(folio)!=0){
                                    let save = 'no'
                                    for (let index = 0; index < this.myDetalle.length; index++) {
                                        const element = this.myDetalle[index];
                                        const params = {
                                            'contrato' : this.contrato,
                                            'user' : this.user,
                                            'folio' : folio,
                                            'fecha' : this.date1,
                                            'rut' : this.rut,
                                            'cliente' : this.cliente,
                                            'sku' : element.sku,
                                            'producto' : element.producto,
                                            'precio' : element.precio,
                                            'cantidad' : element.cantidad,
                                            'total' : element.total,
                                            'forma' : this.forma,
                                            'profesional': this.profesional
                                        };
                                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/venta/',params,{headers});
                                        const datos = res.data;
                                        if(datos[0].existe=='si'){
                                            save = 'si';
                                        }
                                    };
                                    if(save=='si'){
                                        this.btn_venta=true;
                                        this.color_snack='success';
                                        this.mensaje='Venta generada con exito';
                                        this.snack=true;
                                        await this.PDF();
                                    } else {
                                        this.color_snack='error';
                                        this.mensaje='Venta no generada, intentelo mas tarde';
                                        this.snack=true
                                    }
                                } else {
                                    this.color_snack='error';
                                    this.mensaje='Sin folios, intentelo mas tarde';
                                    this.snack=true
                                }
                            } catch (error) {
                            console.log(error) 
                            }
                        }
                    } else {
                        this.color_snack='error';
                        this.mensaje='Ingrese forma de pago';
                        this.snack=true
                    }
                 } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese cliente';
                    this.snack=true
                 }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese productos a la lista';
                this.snack=true
            };
            this.loading=false;
        },
        async PDF(){
             const doc = new jsPDF('p', 'mm', 'letter');

            var img_fondo = document.getElementById("logo_solarium");
            doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

            // //grosor linea
            // doc.setLineWidth(0.2);
            // //horizontal lines
            // doc.line(10, 10, 120, 10);
            // doc.line(10, 40, 120, 40);
            // //vertical lines
            // doc.line(10, 9.5, 10, 40.5);
            // doc.line(120, 9.5, 120, 40.5);

            // doc.setFont("arial", "bold");
            // doc.setFontSize(10);
            // doc.text('SOLARIUM CENTER SPA', 45, 15);
            // doc.setFont("arial", "NORMAL");
            // doc.setFontSize(8);
            // doc.text('RUT:', 45, 21);
            // doc.text('DIRECCION', 45, 26);
            // doc.text('COMUNA:', 80, 31);
            // doc.text('CIUDAD', 45, 31);
            // doc.text('TELEFONO:', 45, 36);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('COMPROBANTE DE VENTA', 145, 15);
            doc.setFont("arial", "NORMAL");
            doc.setFontSize(8);
            doc.text('FECHA:', 150, 21);
            doc.text('' + this.date1, 170, 21);

            doc.line(130, 30, 200, 30);
            doc.line(130, 40, 200, 40);
            //vertical lines
            doc.line(130, 30.5, 130, 40.5);
            doc.line(200, 30.5, 200, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('NÚMERO:', 135, 36);
            doc.setFontSize(12);
            doc.text('' + this.numero_folio, 180, 36);

            doc.line(10, 45, 200, 45);
            doc.line(10, 65, 200, 65);
            //vertical lines
            doc.line(10, 45.5, 10, 65.5);
            doc.line(200, 45.5, 200, 65.5);

            doc.setFontSize(8);
            doc.text('CLIENTE', 15, 51);
            doc.text('RUT', 145, 51);
            doc.text('EMAIL', 15, 56);
            doc.text('TELEFONO', 145, 56);
            doc.text('DIRECCIÓN', 15, 61);

            //datos del cliente
            const data_client = this.myClientes.filter(res => res.Rut == this.rut);
            if(data_client.length!=0){
                doc.setFont("arial", "normal");
                doc.text(':  '+ data_client[0].Cliente, 37, 51);
                doc.text(':  '+ data_client[0].Rut, 175, 51);
                doc.text(':  '+ data_client[0].Email, 37, 56);
                doc.text(':  '+ data_client[0].Telefono, 175, 56);
                doc.text(':  '+ data_client[0].Direccion, 37, 61);
            };

            doc.line(10, 70, 200, 70);
            doc.line(10, 75, 200, 75);
            doc.setFont("arial", "bold");
            doc.text('SKU', 10, 73.5);
            doc.text('PRODUCTO', 30, 73.5);
            doc.text('PRECIO', 150, 73.5, { align: "right" });
            doc.text('CANTIDAD', 180, 73.5, { align: "right" });
            doc.text('TOTAL', 200, 73.5, { align: "right" });
            
            //Detalle
            let suma_total = 0;
            let line = 80;
            doc.setFont("arial", "normal");
            this.myDetalle.forEach(element => {
                doc.text('' + element.sku, 10, line);
                doc.text('' + element.producto, 30, line);
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.precio)), 150, line, { align: "right" });
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad)), 180, line, { align: "right" });
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total)), 200, line, { align: "right" });
                suma_total = parseFloat(suma_total) + parseFloat(element.total);
                line = line + 5;                
            });

            doc.line(10, 225, 200, 225);

            //Total
            doc.line(130, 230, 200, 230);
            doc.line(130, 252, 200, 252);
            //vertical lines
            doc.line(130, 230, 130, 252);
            doc.line(200, 230, 200, 252);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('NETO', 135, 236);
            doc.text('IVA', 135, 242);
            doc.text('TOTAL', 135, 248);

            doc.setFontSize(12);
            const neto = parseFloat(parseFloat(suma_total) / 1.19).toFixed(0);
            const iva = parseFloat(suma_total) - parseFloat(neto);
            doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(neto)), 198, 236, { align: "right" });
            doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(iva)), 198, 242, { align: "right" });
            doc.text('$' + new Intl.NumberFormat("de-DE").format(parseFloat(suma_total)), 198, 248, { align: "right" });
            
            doc.output('dataurlnewwindow')

        },
        async search_number(){
            this.loading=true;            
            if(this.numero!=null && this.numero!=''){
                if(parseInt(this.numero)!=0){
                    try {
                        const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Token ' + this.apikey
                        };
                        const params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'number' : this.numero
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/number/venta/',params,{headers});
                        const datos = res.data;
                        console.log('number venta',datos);
                        if(datos[0].existe=='si'){
                            //datos principales
                            const head_data = datos[0];
                            this.rut = head_data.Rut;
                            this.cliente = head_data.Cliente;
                            this.date1 = head_data.Fecha;
                            this.forma = head_data.Forma;
                            //agregamos el detalle
                            datos.forEach(element => {
                                this.myDetalle.push({
                                    'id': element.ID,
                                    'sku': element.Sku,
                                    'producto': element.Producto,
                                    'precio': element.Precio,
                                    'cantidad': element.Cantidad,
                                    'total': element.Total
                                });
                                this.total_venta = parseFloat(this.total_venta) + parseFloat(element.Total);
                            });
                       } else {
                            this.color_snack='error';
                            this.mensaje='Número de venta no existe';
                            this.snack=true
                       }
                    } catch (error) {
                        console.log(error)
                    };
                    this.d_venta=false
                } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese número de venta';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese número de venta';
                this.snack=true
            };
            this.loading=false;
        },
        async modifica_venta(){
            this.loading=true;
            if(parseFloat(this.total_venta)!=0){
                 if(this.rut!=null && this.rut!='' && this.cliente!=null && this.cliente!=''){
                    if(this.forma!=null && this.forma!=''){
                        //verificar si la fecha ya esta liquidada
                        const verify_date = await this.liquida_date();
                        if(verify_date){
                            this.btn_venta=true;
                            this.color_snack='error';
                            this.mensaje='La fecha ya esta liquidada';
                            this.snack=true
                        } else {
                            try {
                                const headers = {
                                    'Content-Type': 'application/json',
                                    'Authorization': 'Token ' + this.apikey
                                };
                                //obtener el id_venta
                                const folio = this.numero;
                                if(parseInt(folio)!=0){
                                    let save = 'no';
                                    //eliminamos la venta anterior
                                    const params = {
                                        'contrato' : this.contrato,
                                        'user' : this.user,
                                        'number' : folio,
                                    };
                                    const res_venta = await axios.post(process.env.VUE_APP_URL + '/api/v1/delete/venta/',params,{headers});
                                    const datos_venta = res_venta.data;
                                    if(datos_venta[0].existe=='si'){
                                        for (let index = 0; index < this.myDetalle.length; index++) {
                                            const element = this.myDetalle[index];
                                            const params = {
                                                'contrato' : this.contrato,
                                                'user' : this.user,
                                                'folio' : folio,
                                                'fecha' : this.date1,
                                                'rut' : this.rut,
                                                'cliente' : this.cliente,
                                                'sku' : element.sku,
                                                'producto' : element.producto,
                                                'precio' : element.precio,
                                                'cantidad' : element.cantidad,
                                                'total' : element.total,
                                                'forma' : this.forma,
                                                'profesional': this.profesional
                                            };
                                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/venta/',params,{headers});
                                            const datos = res.data;
                                            if(datos[0].existe=='si'){
                                                save = 'si';
                                            }
                                        }
                                    };
                                    if(save=='si'){
                                        this.btn_venta=true;
                                        this.color_snack='success';
                                        this.mensaje='Venta modificada con exito';
                                        this.snack=true;
                                        await this.PDF();
                                    } else {
                                        this.color_snack='error';
                                        this.mensaje='Venta no modificada, intentelo mas tarde';
                                        this.snack=true
                                    }
                                } else {
                                    this.color_snack='error';
                                    this.mensaje='Sin folios, intentelo mas tarde';
                                    this.snack=true
                                }
                            } catch (error) {
                                console.log(error) 
                            }
                        }
                    } else {
                        this.color_snack='error';
                        this.mensaje='Ingrese forma de pago';
                        this.snack=true
                    }
                 } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese cliente';
                    this.snack=true
                 }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese productos a la lista';
                this.snack=true
            };
            this.loading=false;
        }

    }

}
</script>
